import moment, { Moment } from 'moment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Deserializable, DeserializeOptions } from '@app/core/models';
import { StatsGraphType, StatsIntervalsOptions, StatsOptions } from './stats.models';
import { ISODATE_BEGIN } from '@app/shared/consts';
import { FieldInfo } from './field-info.model';

export interface AdditionalFormData {
  type: StatsGraphType,
  controlNames: string[],
  groupOptions: FieldInfo[];
  valueOptions: FieldInfo[];
}

export class StatsOptionsForm extends FormGroup implements Deserializable {

  startDate = this.get('startDate') as FormControl<Moment>;
  endDate = this.get('endDate') as FormControl<Moment>;
  group: FormControl<string> = this.get('group') as FormControl<string>;
  valueControl: FormControl<string> = this.get('value') as FormControl<string>;
  aggFunction: FormControl<string> = this.get('aggFunction') as FormControl<string>;
  filter: FormGroup = this.get('filter') as FormGroup;

  constructor(startDate?: Moment, endDate?: Moment) {
    super({
      startDate: new FormControl(startDate),
      endDate: new FormControl(endDate),
      group: new FormControl(null),
      value: new FormControl(null),
      aggFunction: new FormControl(null, Validators.required),
      filter: new FormGroup({}),
    });
  }

  deserialize?(object: StatsOptions, options?: DeserializeOptions): this {
    const value: any = { };

    if (object?.group) {
      value.group = object.group;
    }
    if (object?.value) {
      value.value = object.value;
    }
    if (object?.aggFunction) {
      value.aggFunction = object.aggFunction;
    }
    if (object?.filter) {
      value.filter = object.filter;
    }
    if (object?.startDate) {
      value.startDate = moment(object.startDate);
    }
    if (object?.endDate) {
      value.endDate = moment(object.endDate);
    }

    this.reset(value, options);
    return this;
  }

  toOptions(): StatsOptions {
    const value = this.value;

    return {
      ...value,
      startDate: value.startDate ? value.startDate.toDate() : null,
      endDate: value.endDate ? value.endDate.toDate() : null,
    };
  }
}

export class StatsIntervalsForm extends StatsOptionsForm {

  unit = this.get('unit') as FormControl<string>;
  amount = this.get('amount') as FormControl<number>;

  constructor() {
    super(moment(ISODATE_BEGIN), moment());
    this.addControl('unit', new FormControl('month'));
    this.addControl('amount', new FormControl(1));
  }


  deserialize?(object: StatsIntervalsOptions, options?: DeserializeOptions): this {
    const value: any = { };

    if (object?.group) {
      value.group = object.group;
    }
    if (object?.value) {
      value.value = object.value;
    }
    if (object?.aggFunction) {
      value.aggFunction = object.aggFunction;
    }
    if (object?.filter) {
      value.filter = object.filter;
    }
    if (object?.unit) {
      value.unit = object.unit;
    }
    if (object?.amount) {
      value.amount = +object.amount;
    }
    if (object?.startDate) {
      value.startDate = moment(object.startDate);
    }
    if (object?.endDate) {
      value.endDate = moment(object.endDate);
    }

    this.reset(value, options);
    return this;
  }

  toOptions(): StatsIntervalsOptions {
    const result = super.toOptions() as StatsIntervalsOptions;
    const value = this.value;

    return {
      ...result,
      unit: value.unit ? value.unit : null,
      amount: value.amount ? +value.amount : null
    };
  }
}
